"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetTasks = exports.deleteManyTasks = exports.deletedOneTask = exports.updatedManyTasks = exports.updatedOneTask = exports.gotManyTasks = exports.gotOneTask = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOneTask = gotOne;
exports.gotManyTasks = gotMany;
exports.updatedOneTask = updatedOne;
exports.updatedManyTasks = updatedMany;
exports.deletedOneTask = deletedOne;
exports.deleteManyTasks = deleteMany;
exports.resetTasks = reset;
//# sourceMappingURL=actions.js.map